import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Redirect, Link } from 'react-router-dom';
import { renderToStaticMarkup } from 'react-dom/server';

import { companyWebsite, name, storageKeys } from 'settings';
import { APIHandler, DataHandler, StorageHandler, SweetAlert, LanguageSelect } from 'C4';

import { toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import InputField from 'components/LoginForm/Input';
import SellingPoints from 'components/SellingPoints';

import logo from 'assets/images/logo/logo.png';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

const NoAgentScreen = () => (
  <div className="noAgent__container">
    <h5>{i18n.translate('loginScreen.noAgent.title')}</h5>
    <p>{i18n.translate('loginScreen.noAgent.messageWeb')}</p>
    <p>
      <a href={companyWebsite}>{companyWebsite}</a>
    </p>
    <a href={companyWebsite}>
      <button>{i18n.translate('loginScreen.noAgent.visitWebsite')}</button>
    </a>
  </div>
);

export default class Email extends Component {
  constructor() {
    super();
    this.state = {
      noAgent: false,
      redirect: '',
      swalOpen: false,
      updateView: false,
      errorMessage: '',
    };

    this.handleCheckEmail = this.handleCheckEmail.bind(this);
    this.login = this.login.bind(this);
    this.loginHandler = this.loginHandler.bind(this);
  }

  componentDidMount() {
    this.ChinaSwal();
  }

  ChinaSwal() {
    StorageHandler.load(storageKeys.lang).then((lang) => {
      if (lang && lang.langFile === 'cn') {
        this.setState({ swalOpen: true });
      } else {
        this.setState({ updateView: true });
      }
    });
  }
  
  async handleCheckEmail(event) {
    event.preventDefault(); 

    const { setAnim, userInput, userExistsHandler } = this.props;
    const { email } = userInput;
    const submit = event.target;
    submit.disabled = true;
    setAnim('loadingAnim', true);
    if (!email) {
      toast.error(`${i18n.translate('loginScreen.version2.errors.fillInEmail')}`, {
        position: toast.POSITION.TOP_CENTER,
      });
      setAnim('loadingAnim', false);
      submit.disabled = false;
    }
    await APIHandler.checkEmail(email).then((res) => {
      this.setState({errorMessage: res.message});
      userExistsHandler(res.success);
      setAnim('loadingAnim', false);
      submit.disabled = false;
    });
  }

  login(userInfo, saveInfo, customRedir) {
    if (saveInfo) StorageHandler.save(storageKeys.user, userInfo, 2592000000);
    document.body.classList.remove('no-scroll');
    this.setState({ redirect: customRedir || '/main' });
  }

  async loginHandler(event) {
    const submit = event.target;
    submit.disabled = true;
    event.preventDefault(); 

    const { checkInputValidity, setAnim, userInput } = this.props;
    const { email, password } = userInput;

    // if (checkInputValidity()) {

      const userExists = await StorageHandler.exists(storageKeys.user);
      if (!userExists) {
        setAnim('loadingAnim', true);
        const appId = await DataHandler.matchAppId();
        const response = await APIHandler.loginUser(email, password);
        const user = await APIHandler.getUser(appId, response.access_token);

        if (response.error || response.success === false) {
          submit.disabled = false;
          toast.error(response.message, {
            position: 'top-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setAnim('loadingAnim', false);
          return;
        }

        StorageHandler.save(storageKeys.accessToken, response.access_token);
        StorageHandler.save(storageKeys.refreshToken, response.refresh_token, response.expires_in);
        setAnim('loadingAnim', true);
        submit.disabled = true;

        // Check if user already has been registered for this if not redirect to register without password
        const registeredForApp = await APIHandler.getUserOld(appId, email);
        if (registeredForApp && registeredForApp.response.sales_companion_registered === null) {
          StorageHandler.save(storageKeys.user, user, 2592000000);
          window.location.replace('/login/quick-register');
          return;
        } else if (registeredForApp && registeredForApp.response.sales_companion_registered === 'null') {
          StorageHandler.save(storageKeys.user, user, 2592000000);
          window.location.replace('/login/quick-register');
          return;
        }

        if (Object.keys(user).length > 0) {
          this.login(user, true);
          return;
        }
      }
      
      StorageHandler.load(storageKeys.user)
        .then((userInfo) => { // Loads userInfo from localStorage
          submit.disabled = false;
          this.login(userInfo, false);
        });
    // } else {
    //   submit.disabled = false;
    //   setAnim('loadingAnimRegister', false);
    // }
  }

  render() {
    const { noAgent, redirect, swalOpen, updateView, errorMessage } = this.state;
    const {
      change, loadingAnim, userExists, userInput,
    } = this.props;

    const close = () => {
      this.setState({
        noAgent: false,
      });
    };

    const close2 = (type) => {
      if (type.dismiss !== 'cancel') {
        window.location.replace('https://mp.weixin.qq.com/s/OLEdCWjtUmrasf3AIM8GIw');
      }
    };

    let buttonText = i18n.translate('loginScreen.version2.continueButton');
    let buttonFunction = this.handleCheckEmail;
    
    let errorCopy = '';
    if (userExists === true) {
      errorCopy = errorMessage;
      buttonText = i18n.translate('loginScreen.version2.loginButton');
      buttonFunction = this.loginHandler;
    }
    if (userExists === false) {
      buttonText = i18n.translate('loginScreen.version2.otherEmailButton');
      buttonFunction = this.handleCheckEmail;
    }

    return (
      <div className="Email">
        <div className="hidden">{updateView}</div>
        <SweetAlert
          trigger={noAgent}
          {...{
            title: '',
            show: noAgent,
            html: renderToStaticMarkup(<NoAgentScreen close={close} />),
            customClass: 'noAgent',
            showConfirmButton: false,
            cancelButtonText: i18n.translate('general.close'),
            showCancelButton: true,
            onConfirm: close,
            onCancel: close,
            onEscapeKey: close,
            onOutsideClick: close,
            onClose: (e) => {
              close();
            },
          }}
        />
        <SweetAlert
          trigger={swalOpen}
          {...{
            title: '欢迎学习「洛杉矶旅游天使成长计划」及「洛杉矶旅游小产品定制师」培训课程',
            show: swalOpen,
            html: '<h4>各位用户：</h4> <p>为推动和促进洛杉矶入境旅游的健康发展，洛杉矶会议及旅游局（LATCB）在2015年特别针对旅游业者推出「洛杉矶旅游天使成长计划」培训课程，诚邀您前来探索和发掘魅力城市―洛杉矶。本课程12个章节，以视频和文字结合的方式，从不同角度介绍洛杉矶特有旅游资源，方便旅行社进行产品设计和线路包装。</p> <p>完成「洛杉矶旅游天使成长计划」课程的后，您还可以继续学习于2018年推出的「洛杉矶旅游小产品定制师」新课程。课程共四章，在「洛杉矶旅游天使成长计划」课程的基础上，进一步细化梳理洛杉矶旅游产品优质资源，深挖新兴旅游热点，让您最新的洛杉矶旅游资源信息。</p><p>通过微信端完成课程的学员有机会获得洛杉矶会议及旅游局颁发的电子证书和精美奖品。扫描下面的二维码，马上开始轻松有趣的学习之旅！更多信息请留意【洛杉矶旅游局天使汇】公共号相关推送，祝您学习愉快！</p>',
            customClass: 'noAgent',
            cancelButtonText: i18n.translate('general.close'),
            confirmButtonText: '继续',
            showCancelButton: true,
            onClose: (e) => {
              close2(e);
            },
            onEscapeKey: close,
            onOutsideClick: close,
          }}
        />
        <h3>{i18n.translate('loginScreen.welcome.headerTop')}</h3>
        <h3>{i18n.translate('loginScreen.welcome.headerBottom')}</h3>
        <SellingPoints />
        <div className="Email__input">
          <div className="Email__input--wrapper">
            <LanguageSelect />
            <div className="inputFields">
              <b>{i18n.translate('loginScreen.version2.homeTitle')}</b>
              <br /><br />
              <legend>
                {i18n.translate('loginScreen.version2.homeTitleSub')}
              </legend>
              {userExists && <legend>
                {!errorCopy.includes('An account has been created') && <p className="warning">{i18n.translate('loginScreen.version2.matchFound')}</p>}
                {errorCopy.includes('An account has been created') && <p className="warning">{errorCopy}</p>}          
              </legend>}
              <InputField
                defaultVal={userExists !== false ? userInput.email : ''}
                change={change}
                fieldType="email"
                fieldName="email"
                fieldPlaceholder={i18n.translate('loginScreen.fields.email')}
                icon="envelope"
                line
                key={userExists}
              />
              {userExists && (
                <InputField
                  change={change}
                  fieldType="password"
                  fieldName="password"
                  fieldPlaceholder={i18n.translate('loginScreen.version2.fields.password')}
                  icon="key"
                  autocomplete="password"
                  line
                />
              )}
              {userExists === false && (
                <p className="warning">
                {i18n.translate('loginScreen.version2.noAccount', { email: userInput.email })}
                </p> 
              )}
            </div>
          </div>

          <div className="login__form--buttons">
            <div className="Email__input--holder">
              <button
                type="button"
                className="loginView__content--request noAgentBtn"
                onClick={() => this.setState({ noAgent: true })}
              >
                {i18n.translate('loginScreen.noAgent.noAgentButton')}
              </button>
              <button
                type="submit"
                onClick={buttonFunction}
                className={`Email__input--button ${userExists === false ? 'btnInverse' : ''}`}
                >
                {loadingAnim ? <span><FontAwesomeIcon icon={['fas', 'circle-notch']} spin /></span> : buttonText}

                {redirect.length > 0 && <Redirect to={redirect} />}
              </button>
              {userExists === false && (
                <Link to="/login/register">
                  <button
                    type="button"
                    className="Email__input--button"
                  >
                    {i18n.translate('loginScreen.version2.register')}
                  </button>
                </Link>
              )}
            </div>
            {userExists && (
              <span className="Email__input--forgotPassword">
                <span>{i18n.translate('loginScreen.version2.fields.forgotSubCopy')}</span>
                <Link to="/login/forgot">
                  {i18n.translate('loginScreen.forgot')}
                </Link>
                <br /><br />
                <span> {i18n.translate('loginScreen.version2.fields.forgotSubCopy2')} </span>
                <Link
                  to="/login/magic-link"
                  >
                  {i18n.translate('loginScreen.version2.magicLinkButton')}
                </Link>
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }
}

Email.propTypes = {
  change: PropTypes.func.isRequired,
  checkInputValidity: PropTypes.func.isRequired,
  loadingAnim: PropTypes.bool.isRequired,
  setAnim: PropTypes.func.isRequired,
  userInput: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
    reg_email: PropTypes.string,
    reg_first_name: PropTypes.string,
    reg_last_name: PropTypes.string,
    reg_agency_name: PropTypes.string,
    reg_state: PropTypes.string,
  }),
  userExists: PropTypes.bool,
  userExistsHandler: PropTypes.func.isRequired,
};

Email.defaultProps = {
  userInput: {
    email: '',
    password: '',
    reg_email: '',
    reg_first_name: '',
    reg_last_name: '',
    reg_agency_name: '',
    reg_state: '',
  },
  userExists: null,
};
